<template>
  <div class="row row-calendar">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center">
          <div class="calendar-nav-wrapp">
            <div class="calendar-nav">
              <span @click="prevMonth" class="forecast-calendar-prev"></span>
              <span class="forecast-calendar-month">{{monthTitle}}</span>
              <span @click="nextMonth" class="forecast-calendar-next"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="forecast-month">
            <div class="calendar-inputs style">
              <table>
                <thead>
                  <tr>
                    <th>пн</th>
                    <th>вт</th>
                    <th>ср</th>
                    <th>чт</th>
                    <th>пт</th>
                    <th>сб</th>
                    <th>вс</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(week, idx) in weeks" :key="idx">
                    <ProductionDay v-for="(day, dayIdx) in week" :day="day" :key="dayIdx"></ProductionDay>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="calendar-save text-center"><span @click="updateProduction" class="confirm">сохранить выработку</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StationAPI from '@/api/station'
import moment from 'moment'
import CalendarDay from '@/components/station-create/CalendarDay'
import ProductionDay from '@/components/station-create/ProductionDay'

const MONTHS = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь'
]

export default {
  name: 'ProductionCalendar',
  components: { ProductionDay },
  props: {
    stationId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      production: null,
      month: moment().format('YYYY-MM'),
      weeks: []
    }
  },
  computed: {
    monthTitle () {
      return `${MONTHS[ moment(this.month, 'YYYY-MM').month() ]} ${moment(this.month)
        .format('YYYY')}`
    }
  },
  methods: {
    updateProduction () {
      const data = []

      this.weeks.forEach(week => week.forEach(day => {
        if (day.isChanged()) {
          data.push({
            time: day.date.format('YYYY-MM-DD'),
            production: Number(day.value)
          })
        }
      }))

      StationAPI.updateProduction(this.stationId, data)
        .then(() => {
          this.$notify({
            title: 'Успех',
            type: 'success',
            text: 'Выработка сохранена'
          })

          this.loadProductionAndWeeks()
        })
        .catch(error =>
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ошибка!',
            text: error.message
          })
        )
    },
    nextMonth () {
      this.month = moment(this.month, 'YYYY-MM').add(1, 'month').format('YYYY-MM')
      this.weeks = this.getWeeks()
    },
    prevMonth () {
      this.month = moment(this.month, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
      this.weeks = this.getWeeks()
    },
    getWeeks () {
      const currentMonth = moment(this.month, 'YYYY-MM')

      const a = moment(currentMonth).startOf('month')
      const b = moment(currentMonth).endOf('month')

      const days = []

      // add all days of month
      for (let i = 0; i <= b.diff(a, 'days'); i++) {
        const day = new CalendarDay()
        day.date = moment(a).add(i, 'days')
        day.isBlank = false

        if (this.production.has(day.date.format('YYYY-MM-DD'))) {
          day.value = this.production.get(day.date.format('YYYY-MM-DD'))
          day.initValue = day.value
        }

        days.push(day)
      }
      // add black days at beginning
      let daysToAdd = a.isoWeekday() - 1

      while (daysToAdd > 0) {
        days.unshift(new CalendarDay())
        daysToAdd--
      }

      // add blank days at the end
      daysToAdd = 7 - b.isoWeekday()

      while (daysToAdd > 0) {
        days.push(new CalendarDay())
        daysToAdd--
      }

      // split by 7
      const weeks = []
      let week = []
      days.forEach(day => {
        week.push(day)
        if (week.length === 7) {
          weeks.push(week)
          week = []
        }
      })

      return weeks
    },
    loadProductionAndWeeks () {
      StationAPI.production(this.stationId).then(r => {
        this.production = r.data.reduce((map, value) => {
          map.set(moment(value.time).format('YYYY-MM-DD'), value.production)
          return map
        }, new Map())

        this.weeks = this.getWeeks()
      })
    }
  },
  mounted () {
    this.loadProductionAndWeeks()
  }
}
</script>
